export default {
      id: "ic-deadline-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-deadline-usage",
      toString: function () {
        return this.url;
      }
    }